<template>
  <nav class="main-nav">
    <!-- Logo区域 -->
     <div class="nav-box">
      <div class="nav-logo">
        <img :src="logoUrl" alt="助力通logo" class="logo-img" />
      </div>
      <!-- 导航菜单 -->
      <ul class="nav-menu">
        <router-link
        :to="item.path"
        class="menu-item"
        active-class="active-item"
        v-for="item in navItems"
        :key="item.path">
          {{ item.title }}
        </router-link>
      </ul>
    </div>
  </nav>
</template>

<script setup lang="ts">
  import { ref, onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import { getHost } from '@/utils/domain.js';
  import { getSiteHostInfo } from '@/apis/modules/login/login';

  // const router = useRouter();

  interface NavItem {
    path: string;
    title: string;
    // 新增匹配规则
    matchPattern?: string[];
  }

  const route = useRoute();
  const logoUrl = ref('');

  const navItems: NavItem[] = [
    { path: '/home', title: '首页' },
    {
      path: '/domesticLogistics',
      title: '国内物流',
      // 匹配所有国内物流相关子路由
      matchPattern: [
        '/domesticLogistics',
        '/logisticParticulars',
        '/logisticOrder'
      ]
    },
    { path: '/internationalLogistics', title: '国际物流' },
    { path: '/factoryView/index', title: '工厂企业' },
    { path: '/freightSource', title: '货源信息' },
    { path: '/vehicleSource', title: '车源信息' },
    // { path: '/logisticsPark', title: '物流园区' },
    { path: '/logisticsInformation', title: '物流资讯' },
    { path: '/platformIntroduction', title: '平台简介' },
  ];

  // 获取站点logo
  const fetchSiteLogo = async () => {
    try {
      // 设置默认logo
      logoUrl.value = require('@/assets/zhultLogo.png');
      const host = getHost();
      const res = await getSiteHostInfo({ adHost: host });
      if (res && res.statusCode === 20000 && res.data && res.data.siteLogo) {
        logoUrl.value = res.data.siteLogo;
        console.log('站点logo:', res.data.siteLogo);
      }
    } catch (error) {
      console.error('获取站点logo失败:', error);
      if (!logoUrl.value) {
        logoUrl.value = require('@/assets/zhultLogo.png');
      }
    }
  };

  onMounted(() => {
    fetchSiteLogo();
  });

  const isActive = (item: NavItem) => {
    // 调试输出
    console.log(`Checking ${item.title} (${item.path}) against ${route.path}`)

    // 优先使用匹配规则
    if (item.matchPattern) {
      const currentPath = route.path.replace(/\/$/, '')
      return item.matchPattern.some(pattern => {
        const normalizedPattern = pattern.replace(/\/$/, '')
        return currentPath.startsWith(normalizedPattern)
      })
    }

    // 普通路径匹配
    return route.path === item.path;
  };
</script>

<style scoped lang="scss">
  .main-nav {
    height: 98px;
    width: 100%;
    background: #031f53;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    .nav-box{
      width: 1400px;
      height: 100%;
      display: flex;
      align-items: center;
      .nav-logo {
        width: 130px;
        height: 54px;
        margin-right: 296px;
        .logo-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .nav-menu {
        display: flex;
        flex-grow: 1;
        list-style: none;
        align-items: center; /* 保证垂直居中 */
        height: 100%; /* 继承父级高度 */
        .menu-item {
          width: 120px;
          height: 98px;
          display: flex;
          align-items: center;
          justify-content: center;
          //字体
          font-family: PingFang SC;
          font-size: 18px;
          font-weight: 500;
          line-height: 36px;
          letter-spacing: normal;
          color: #ffffff;
          text-decoration: none;//去掉下划线
          position: relative;
          overflow: hidden; /* 隐藏超出部分 */
        }
        .menu-item::after{
          //正常状态下划线隐藏
          content: '';
          position: absolute;
          bottom: 0px;
          width: 48px;
          height: 0px;
          transform: translateX(-100%); // 初始在左侧外部
          transition: transform 0.3s ease; // 只过渡 transform
        }
        .active-item {
          font-weight: bold;
          color: #ffba2f;
          background: #00246D;
        }
        .active-item::after {
        //激活状态下划线
        width: 48px;
        height: 6px;
        background: #ffba2f;
        transform: translateX(0%); // 移动到左侧

        }
        .menu-item:hover {
          color: #ffba2f;
        }
      }
    }
  }
  /* 响应式处理 */
  @media (max-width: 1280px) {
    .nav-menu {
      gap: 24px;
    }
  }
</style>
